/**
 * An idea's stage and what it needs: the rules live in @mycompbox/shared
 * (idea-stage.ts) so the API's stage filters and counts agree with the web.
 * The words for each "needs you" reason live here.
 */
import type { NeedsYou } from "@mycompbox/shared";

export { stageOf } from "@mycompbox/shared";
export type { IdeaStageInput, IdeaStageResult, NeedsYou, JobFacts } from "@mycompbox/shared";

export const NEEDS_YOU_TEXT: Record<NeedsYou, string> = {
  answer_idea_helper: "Answer the Idea helper",
  answer_blueprint_maker: "Answer the Blueprint maker",
  answer_builder: "Answer the Builder",
  merge_prs: "Merge the pull requests",
  decide_build: "Decide what to do with the build",
  review_build: "Review the finished build",
  make_blueprint: "Make the blueprint",
};
